import { PlayIcon, SquareIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { EditablePhraseType } from '@/entities/conversations';
import { type EditedInterval, useDialogSessionOptional } from '@/features/DialogSession';
import { IconButton } from '@/shared/ui';

type Props = {
  type: EditablePhraseType;
  /** Отрезок записи; null — границы не заданы целиком или несогласованы, слушать нечего */
  interval: EditedInterval | null;
};

/**
 * Прослушивание отрезка записи — от её начала до конца. Нажатие во время прослушивания его останавливает.
 */
export const TranscriptListenButton: FC<Props> = ({ type, interval }) => {
  const { t } = useTranslation(['dialogs']);
  const session = useDialogSessionOptional();

  const playingInterval = session?.playingInterval;
  const isListening =
    !!session?.isPlaying &&
    !!interval &&
    playingInterval?.startedAt === interval.startedAt &&
    playingInterval.finishedAt === interval.finishedAt;
  const isUnavailable = !session || session.audioStatus !== 'ready' || !interval;

  const handleClick = () => {
    if (!session || !interval) return;
    if (isListening) {
      session.pause();
      return;
    }
    session.playInterval(interval);
  };

  return (
    <IconButton
      size="icon"
      icon={isListening ? <SquareIcon /> : <PlayIcon />}
      label={isListening ? t('dialogs:transcriptEdit.stopListening') : t(`dialogs:transcriptEdit.listenRecord.${type}`)}
      disabled={isUnavailable}
      onClick={handleClick}
    />
  );
};
